import { PropTypes } from "base/react-libs";
import { useState, useEffect, useMemo, useContext } from "react";
import { percentOfTasksComplete } from "apps/journeys/utils/helpers";
import TaskRowDetails from "./task-row-details";
import TaskRowSummary from "./task-row-summary";
import { JourneysContext } from "apps/journeys/context/journeys-context";

const JourneysTaskTableRow = ({ step }) => {
  const { handleTaskRemovalStateUpdate, handleTaskUpdateStateUpdate, fetchJourneysAgainAfterDelay } = useContext(JourneysContext);

  const [isExpanded, setIsExpanded] = useState(false);
  const [tasks, setTasks] = useState([]);
  useEffect(() => setIsExpanded(false), [step]);
  useEffect(() => {
    setTasks(step.tasks ? step.tasks : []);
  }, [step.tasks]);

  const completionPercentage = useMemo(() => percentOfTasksComplete(tasks), [tasks]);

  const handleTaskCompletionStateChangeSmall = (task, completed_at) => {
    const tasksCopy = [...tasks];
    const taskCopy = tasksCopy.find((t) => t.id === task.id);
    taskCopy.completed_at = completed_at;
    setTasks(tasksCopy);
  };

  const handleRemove = (task) => {
    const tasksCopy = [...tasks];
    const filtered = tasksCopy.filter((t) => !(t.id === task.id));

    setTasks(filtered);
    handleTaskRemovalStateUpdate(step.id, filtered);
    fetchJourneysAgainAfterDelay();
  };

  const handleUpdate = (task) => {
    handleTaskUpdateStateUpdate(task);
  };

  return (
    <div className="journeys-task-table--row">
      <TaskRowSummary
        step={step}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        completionPercentage={completionPercentage}
      />
      {isExpanded && (
        <TaskRowDetails
          step={step}
          tasks={tasks}
          handleTaskCompletionStateChangeSmall={handleTaskCompletionStateChangeSmall}
          handleRemove={handleRemove}
          handleUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

JourneysTaskTableRow.propTypes = {
  step: PropTypes.object,
};

export default JourneysTaskTableRow;
